import { render, staticRenderFns } from "./GridSizeSelector.vue?vue&type=template&id=174396df&scoped=true&"
import script from "./GridSizeSelector.vue?vue&type=script&lang=js&"
export * from "./GridSizeSelector.vue?vue&type=script&lang=js&"
import style0 from "./GridSizeSelector.vue?vue&type=style&index=0&id=174396df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174396df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VList,VListItem,VMenu,VSpacer})
